var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 47.9998,
    r: 43.2,
    fill: "#FCD7E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7782 30.9001C24.6309 29.7877 25.4965 28.7998 26.6187 28.7998L36.7625 28.7998C37.262 28.7998 37.7403 29.001 38.0896 29.3581L39.606 30.9082C39.9553 31.2652 40.4337 31.4665 40.9331 31.4665H70.3605C71.4899 31.4665 72.3576 32.4665 72.1984 33.5847L67.6401 65.6049C67.5098 66.5199 66.7263 67.1998 65.8021 67.1998H31.2138C30.2827 67.1998 29.4956 66.5101 29.3733 65.5871L24.7782 30.9001Z",
    fill: "#ED0973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5959 40.5133C23.4396 39.3965 24.3068 38.3994 25.4345 38.3994H71.5654C72.6931 38.3994 73.5604 39.3965 73.404 40.5133L69.8919 65.6003C69.7635 66.5172 68.9791 67.1994 68.0533 67.1994H28.9467C28.0208 67.1994 27.2365 66.5172 27.1081 65.6003L23.5959 40.5133Z",
    fill: "#F2539D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7412 53.6569C50.523 53.6569 50.3461 53.8338 50.3461 54.052V58.4047C50.3461 58.6229 50.1692 58.7998 49.951 58.7998H47.0489C46.8307 58.7998 46.6538 58.6229 46.6538 58.4047V54.052C46.6538 53.8338 46.4769 53.6569 46.2587 53.6569H44.4588C44.1392 53.6569 43.9518 53.2971 44.1352 53.0353L48.1763 47.2622C48.3336 47.0375 48.6664 47.0375 48.8237 47.2622L52.8648 53.0353C53.0481 53.2971 52.8608 53.6569 52.5411 53.6569H50.7412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/fileUploadIcon.8fcb34e6be86579b0eaeec75b371a566.svg";
export { ForwardRef as ReactComponent };